import { bus } from "@/main";

export default {
	name: "LogoBlock",
	data() {
		return {
			title: "Porto Design Biennale",
			porto: "Porto",
			design: "Design",
			biennale: "Biennale",
			year: "2019",
			titleRendered: "Porto Design Biennale",
			portoRendered: null,
			designRendered: null,
			biennaleRendered: null,
			yearRendered: null,
			isAnimated: true,
			randomized: false
		}
	},
	props:[
		"showYear",
		"grid",
		"type",
		"small",
		"animated",
	],
	created() {
	},
	computed: {
		pageUrl: function () {
			return location.href;
		}
	},
	mounted() {
		// this.weightChange();
		this.textChange();
		setTimeout(() => {
			if(!this.randomized)
				this.logoVar();
		}, 600);
	},
	watch: {
		"small": function() {
			this.textChange()
		}
	},
	methods: {
		logoVar() {
			let logo = document.getElementById("logo-random").children;
			let random = 1;
			let randomClass = 1;

			// if (this.animated) {
				// setInterval(() => {
					// random = Math.floor((Math.random() * 6) + 1);

				for (let i = 0; i < logo.length;) {
					let word = logo[i]
					
					for (let j = 0; j < word.children.length;) {
						const element = word.children[j];
							
						if (element.classList.contains("logo__fill") == false) {

							randomClass = Math.floor((Math.random() * 6) + 1);
							element.classList.remove("animation-1", "animation-2", "animation-3", "animation-4", "animation-5", "animation-6")

							if (element.children[0].innerHTML == "n") {
								// console.log("N")
								if (randomClass == 1 || randomClass == 2 || randomClass == 3)
									element.classList.add("animation-5")
								if (randomClass == 4 || randomClass == 5 || randomClass == 6)
									element.classList.add("animation-4")
							}
							else
								element.classList.add("animation-" + randomClass)
						}
						j++;
					}
					i++;
				}

			this.randomized = true;
				// }, random * 2000);
			// }
		},
		textChange() {
			let logo = document.getElementById("logo-random");

			if (this.small) {
				this.porto = "P";
				this.design = "D";
				this.biennale = "B";
				logo.classList.add("logo--flex");
			} else {
				this.porto = "Porto";
				this.design = "Design";
				this.biennale = "Biennale";
				logo.classList.remove("logo--flex");
			}

			this.titleSplit();

			this.lineFull = !this.lineFull;
		},
		titleSplit() {
			this.portoRendered = this.porto.split('');
			this.designRendered = this.design.split('');
			this.biennaleRendered = this.biennale.split('');
			this.yearRendered = this.year.split('');
		},
	}
}



// WEBPACK FOOTER //
// ./src/components/blocks/logo-block/logo.block.js